import { render, staticRenderFns } from "./V2Select.vue?vue&type=template&id=239c8cda&scoped=true&"
import script from "./V2Select.vue?vue&type=script&lang=js&"
export * from "./V2Select.vue?vue&type=script&lang=js&"
import style0 from "./V2Select.vue?vue&type=style&index=0&id=239c8cda&lang=scss&scoped=true&"
import style1 from "./V2Select.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239c8cda",
  null
  
)

export default component.exports